<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">Table of Contents</h3>
			<a class="btn btn-sm btn-primary ml-auto" href="#" style="margin-bottom: 5px;" @click.prevent="updateToc"><i class="fas fa-fw fa-sync-alt"></i>Refresh</a>
		</header>
		<div class="card-body">
			<label>
				<input type="checkbox" v-model="reviewContent.translations[clickedLang].user_review_toc">
				<span>User review</span>
			</label>
			<hr style="margin: 15px 0 10px;" />
			<label v-for="elem in tableOfContents[clickedLang]" class="label-checkbox">
				<input type="checkbox" v-model="elem.checked">
				<span>{{ elem.content }}</span>
			</label>
		</div>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";
	import he from "../../../../../node_modules/he";

	export default {
		props: {
			tableOfContents: {
				required: true
			},
			editorContent: {
				reviewContent: {}
			},
		},
		data() {
			return {
				clickedLang: this.$defaultLanguage.locale,
				reviewContent: this.editorContent,
			}
		},
		created() {
			let vm = this;

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});

			eventBus.$on('onReviewContentUpdate', function (data) {
				vm.tableOfContents[vm.clickedLang] = [];
				for (let i = 0; i < data.length; i++) {
					let tag = data[i].children[0];
					while (!tag.hasOwnProperty('data')) {
						tag = tag.children[0];
					}
					vm.tableOfContents[vm.clickedLang].push({
						content: he.decode(tag.data),
						id: tag.data,
						checked: true
					})
				}
			});
		},
		methods: {
			updateToc: function () {
				eventBus.$emit('onTocUpdate');
			}
		}
	}
</script>

<style scoped>

</style>
